export default "__VITE_ASSET__Dvb56iKk__"